import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors, FormArray } from '@angular/forms';
import { CustomerGuide } from '../../../class/customer-guide';
import { CustomerGuideService } from '../../../service/customer-guide/customer-guide.service';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { CompanyService } from '../../../service/company/company.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { Message, FileUpload } from 'primeng/primeng';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { CustomerGuideHseDocumentsService } from '../../../service/customer-guide-hse-document/customer-guide-hse-document.service';
import { config } from '../../../../../../environments/config';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { formatDateWithouthHourConditional } from '../../../../../theme/functions/formatDateWithouthHourConditional.function';
import { calendarES } from '../../../../../theme/functions/calendarES';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-new-customer-guide',
  templateUrl: './new-customer-guide.component.html',
  styleUrls: ['./new-customer-guide.component.scss']
})
export class NewCustomerGuideComponent implements OnInit {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() edit: CustomerGuide;
  public promiseForm: Promise<any>;
  public form: FormGroup;

  public uploadedProfessiogram: any[] = [];
  public prewiewProfessiogram: any;
  public promiseProfessiogram: Promise<any>;

  public uploadedFileSelection: any[] = [];
  public prewiewFileSelection: any;
  public promiseFileSelection: Promise<any>;
  public typesDocumentsCustomerGuide: { key: string, value: string, id: number }[] = [
    { key: 'commercial_chamber_certificate', value: 'Commercial Chamber Certificate (less than 30 days)', id: 1 },
    { key: 'rut_certificate', value: 'RUT Certificate (less than 30 days)', id: 2 },
    { key: 'financial_statements', value: 'Financial Statements 2022-2023', id: 3 },
    { key: 'company_income_tax_declaration', value: 'Company Income Tax Declaration', id: 4 },
    { key: 'copy_of_legal_representative_id', value: 'Copy of Legal Representative’s ID', id: 5 },
    { key: 'central_consultation_form', value: 'Central Consultation Form', id: 6 },
    { key: 'minimum_standards_certificate_from_arl_of_affiliation', value: 'Minimum Standards Certificate from ARL of Affiliation', id: 7 },
    { key: 'anti_money_laundering_declaration', value: 'Anti-Money Laundering Declaration', id: 8 },
    { key: 'customer_guide_format', value: 'Customer Guide Format', id: 9 },
    { key: 'commercial_proposal', value: 'Commercial Proposal', id: 10 },
    { key: 'commercial_contract', value: 'Commercial Contract', id: 11 },
    { key: 'guarantees_or_payment', value: 'Guarantees Or Payment', id: 12 }
  ];
  public documents_guide_customer: FormGroup;
  public removedDocumentIds: number[] = [];

  public uploadedServiceClientFileReport: any[] = [];
  public prewiewServiceClientFileReport: any;
  public promiseServiceClientFileReport: Promise<any>;

  public apiUrl = config.API_ROOT;

  public msgs: Message[];

  public display: boolean;
  public company_latitude: any;
  public company_longitude: any;
  public company_addressGoogle: string;
  public company_overlays: any[];
  public company_selectedPosition: any;

  public optionsSelectionDossier: any[];
  public optionsHirePayTest: any[];
  public optionsSupplyPerson: any[];
  public optionsEconomySector: any[];
  public optionsPaymentFrecuency: any[];
  public optionsAccountancyRegimenTax: any[];
  public optionsPaymentMonthManagement: any[];
  public listDocuments: any[] = [];
  public loading_upload: boolean = false;

  @ViewChild('search') public searchElementRef: ElementRef;
  public zoom: number;
  public marker: Marker;

  public es: any;

  public save_exit: boolean;

  private id: number;
  public showPage: number;

  public list_documents_customer_guide_hse: any[] = [];
  public documents_hse: any[] = [];

  constructor(
    public fb: FormBuilder,
    public customerGuideService: CustomerGuideService,
    public companyService: CompanyService,
    public translate: TranslateService,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    public hasPermissionService: HasPermissionService,
    public uploadFilesService: UploadFilesService,
    public customerGuideHseDocumentsService: CustomerGuideHseDocumentsService,
    private notificationsService: NotificationsService,
    private router: Router,
    private route: ActivatedRoute,
  ) {

    this.save_exit = false;

    this.display = false;

    this.es = calendarES();

    this.optionsSelectionDossier = [];
    this.optionsSelectionDossier.push({ label: 'Indicadores', value: 'Indicadores' });
    this.optionsSelectionDossier.push({ label: 'BD Mes Anterior', value: 'BD Mes Anterior' });
    this.optionsSelectionDossier.push({ label: 'Indicadores y BD', value: 'Indicadores y BD' });

    this.optionsHirePayTest = [];
    this.optionsHirePayTest.push({ label: 'Redes Humanas', value: 'Redes Humanas' });
    this.optionsHirePayTest.push({ label: 'Empresa Usuaria', value: 'Empresa Usuaria' });
    this.optionsHirePayTest.push({ label: 'Redes Humanas / Empresa Usuaria', value: 'Redes Humanas / Empresa Usuaria' });
    this.optionsHirePayTest.push({ label: 'Otro', value: 'Otro' });

    this.optionsSupplyPerson = [];
    this.optionsSupplyPerson.push({ label: 'Redes Humanas', value: 'Redes Humanas' });
    this.optionsSupplyPerson.push({ label: 'Empresa Usuaria', value: 'Empresa Usuaria' });

    this.optionsEconomySector = [
      { label: 'Agrícola', value: 'Agrícola' },
      { label: 'Comercio', value: 'Comercio' },
      { label: 'Comunicaciones', value: 'Comunicaciones' },
      { label: 'Construcción', value: 'Construcción' },
      { label: 'Financiero', value: 'Financiero' },
      { label: 'Industria', value: 'Industria' },
      { label: 'Minero y Energético', value: 'Minero y Energético' },
      { label: 'Servicios', value: 'Servicios' },
      { label: 'Transporte', value: 'Transporte' }
    ];

    this.optionsPaymentFrecuency = [];
    this.optionsPaymentFrecuency.push({ label: 'Semanal', value: 'Semanal' });
    this.optionsPaymentFrecuency.push({ label: 'Quincenal', value: 'Quincenal' });
    this.optionsPaymentFrecuency.push({ label: 'Mensual', value: 'Mensual' });

    this.optionsAccountancyRegimenTax = [];
    this.optionsAccountancyRegimenTax.push({ label: 'Común', value: 'Común' });
    this.optionsAccountancyRegimenTax.push({ label: 'Simplificado', value: 'Simplificado' });

    this.optionsPaymentMonthManagement = [];
    this.optionsPaymentMonthManagement.push({ label: 'Comercial 30 Días', value: 'Comercial 30 Días' });
    this.optionsPaymentMonthManagement.push({ label: 'Calendario 31 Días', value: 'Calendario 31 Días' });

    // this.list_documents_customer_guide_hse = [
    //   {id: 1, name: 'Hallazgos'},
    //   {id: 2, name: 'Seguimiento'},
    // ];

    // this.company_latitude = 39.8282;
    // this.company_longitude = -98.5795;
    this.company_addressGoogle = '';
    this.company_overlays = [];
    this.company_selectedPosition = '';

    // set google maps defaults
    this.zoom = 2;
    this.company_latitude = 39.8282;
    this.company_longitude = -98.5795;

    this.marker = {
      lat: this.company_latitude,
      lng: this.company_longitude,
      label: 'Company',
      draggable: true
    };
  }

  ngOnInit() {
    this.id = +this.route.snapshot.paramMap.get('customer_guide_id');
    // console.log("el id es " + this.id);

    // Inicialización de documentsGuideForm
    this.documents_guide_customer = this.fb.group({
      commercial_chamber_certificate: this.fb.array([]),
      rut_certificate: this.fb.array([]),
      financial_statements: this.fb.array([]),
      company_income_tax_declaration: this.fb.array([]),
      copy_of_legal_representative_id: this.fb.array([]),
      central_consultation_form: this.fb.array([]),
      minimum_standards_certificate_from_arl_of_affiliation: this.fb.array([]),
      anti_money_laundering_declaration: this.fb.array([]),
      customer_guide_format: this.fb.array([]),
      commercial_proposal: this.fb.array([]),
      commercial_contract: this.fb.array([]),
      guarantees_or_payment: this.fb.array([]),
    });

    if (this.id !== 0 && this.id !== undefined) {
      this.customerGuideService.infoCustomerGuide(this.id).toPromise().then(
        response => {
          // console.log(response);
          this.showPage = 1;
          this.edit = response.json();
          this.editValues();
          this.getListDocumentsHseCustomerGuide(this.id);
          this.populateFormArrays(this.edit);
        },
        error => {
          this.notificationsService.growlNotify('error', 'ID ' + this.id + ' no encontrado');
          this.router.navigateByUrl('/pages/customer-guides');
          // this.showPage = 1;
        }
      );
    } else {
      this.showPage = 1;
      this.defaultValues();
    }

    // Load Places Autocomplete (si es necesario)
  }

  public createForm(data: any = null) {
    data = data || {
      // customer guide
      contract_number: '',
      start_contract_date: null,
      end_contract_date: null,
      economy_sector: '',
      aiu: '',
      owner_account: '',
      info_comercial_management: '',
      info_service_client: '',
      cmb_neg_special: false,
      neg_special: '',
      activated: '',
      observation_professiogram: '',

      // company
      company: {
        identification_number: '',
        name: '',
        economic_activity: '',
        legal_representative_identification_number: '',
        legal_representative_name: '',
        legal_representative_employee_position: '',
        director_rrhh: '',
        city: '',
        phone: '',
        web: '',
        inscription_cc_at: '',
        mission: '',
        vission: '',
        corporate_values: '',
        address_description: '',
        parking: false,
        food: false,
        transport: false,
        noise: false,
        vent: false,
        ilumination: false,
        order: false,
        temperature_regulator: false,
        fortress: '',
        address: '',
      },

      // supplies
      supply_type: '',
      supply_person: '',
      supply_information: '',

      // service_client
      service_client_contact_atc: '',
      service_client_frecuency_visit: '',
      service_client_email: '',
      service_client_mobile: '',
      service_client_facilitator: false,
      service_client_facilitator_person: '',
      service_client_schedule: '',
      service_client_report: false,
      service_client_aditional_information: '',

      // hse
      hse_contact: '',
      hse_contact_employee_position: '',
      hse_contact_email: '',
      hse_contact_phone: '',
      hse_arl_base: '',
      hse_risk: '',
      hse_additional_information: '',

      // selection
      selection_contact: '',
      selection_contact_employee_position: '',
      selection_contact_email: '',
      selection_contact_phone: '',
      selection_contact_mobile: '',
      selection_contact_employee_position_provider: '',
      selection_dossier_required: false,
      selection_dossier: '',
      selection_schedule: '',
      selection_additional_information: '',
      first_day_instruction: '',
      selection_family_restriction: false,
      unique_contact: false,
      selection_show_more_contact: false,
      selection_contact2: '',
      selection_contact_email2: '',
      selection_contact_phone2: '',
      selection_contact3: '',
      selection_contact_email3: '',
      selection_contact_phone3: '',
      selection_contact4: '',
      selection_contact_email4: '',
      selection_contact_phone4: '',
      selection_contact5: '',
      selection_contact_email5: '',
      selection_contact_phone5: '',

      // hire
      hire_contact: '',
      hire_contact_employee_position: '',
      hire_contact_email: '',
      hire_contact_phone: '',
      hire_pay_test: '',
      hire_other_test: '',
      hire_pay_test_person: '',
      hire_lab_test: '',
      hire_center_cost: false,
      hire_show_more_contact: false,
      hire_contact2: '',
      hire_contact_email2: '',
      hire_contact_phone2: '',
      hire_contact3: '',
      hire_contact_email3: '',
      hire_contact_phone3: '',
      hire_contact4: '',
      hire_contact_email4: '',
      hire_contact_phone4: '',
      hire_contact5: '',
      hire_contact_email5: '',
      hire_contact_phone5: '',
      hire_description: '',
      hire_clausulas: '',
      hire_additional_information: '',

      // payment
      payment_contact: '',
      payment_contact_employee_position: '',
      payment_contact_email: '',
      payment_contact_phone: '',
      payment_frecuency: '',
      payment_date: '',
      payment_day: '',
      payment_peace_save: false,
      payment_biometric_capture: false,
      payment_date_end_invoce: '',
      payment_month_management: '',
      payment_additional_information: '',
      payment_accounting_software: '',
      payment_ss_operator: '',

      // accountancy
      accountancy_contact: '',
      accountancy_contact_employee_position: '',
      accountancy_contact_email: '',
      accountancy_contact_phone: '',
      accountancy_invoice_address: '',
      accountancy_regimen_tax: '',
      accountancy_big_taxpayer: false,
      accountancy_autoretainer: false,
      accountancy_days_invoce_expiration: '',
      accountancy_days_invoce_radication: '',
      accountancy_additional_information: '',
    };

    let companyPermissions = this.hasPermission('get company') && this.hasPermission('edit company');
    let customerGuidePermissions = this.hasPermission('edit customer guide contract number');
    let aiuPermissions = this.hasPermission('get aiu') && this.hasPermission('edit aiu');
    let supplyPermissions = this.hasPermission('get supply') && this.hasPermission('edit supply');
    let serviceClientPermissions = this.hasPermission('get service-client') && this.hasPermission('edit service-client');
    let hsePermissions = this.hasPermission('get hse') && this.hasPermission('edit hse');
    let selectionPermissions = this.hasPermission('get selection') && this.hasPermission('edit selection');
    let hirePermissions = this.hasPermission('get hire') && this.hasPermission('edit hire');
    let paymentPermissions = this.hasPermission('get payment') && this.hasPermission('edit payment');
    let accountancyPermissions = this.hasPermission('get accountancy') && this.hasPermission('edit accountancy');
    let userCompanyPermissions = this.hasPermission('get user company');

    this.form = this.fb.group({

      // customer guide
      contract_number: new FormControl({ value: data.contract_number, disabled: (!companyPermissions && !customerGuidePermissions) }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      start_contract_date: new FormControl({ value: data.start_contract_date, disabled: (!companyPermissions && !customerGuidePermissions) }, null), //companyPermissions ? Validators.compose([ Validators.required ]) : null
      end_contract_date: new FormControl({ value: data.end_contract_date, disabled: (!companyPermissions && !customerGuidePermissions) }, null), // companyPermissions ? Validators.compose([ Validators.required ]) : null
      economy_sector: new FormControl({ value: data.economy_sector, disabled: !companyPermissions }, (customerGuidePermissions) ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      aiu: new FormControl({ value: data.aiu, disabled: !aiuPermissions }, (aiuPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(30)]) : null),
      owner_account: new FormControl({ value: data.owner_account, disabled: !companyPermissions }, (companyPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      info_comercial_management: new FormControl({ value: data.info_comercial_management, disabled: !companyPermissions }, (companyPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),
      info_service_client: new FormControl({ value: data.info_service_client, disabled: !companyPermissions }, (companyPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(4500)]) : null),
      cmb_neg_special: new FormControl({ value: data.cmb_neg_special, disabled: !companyPermissions }, (companyPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required]) : null),
      neg_special: new FormControl({ value: data.neg_special, disabled: !companyPermissions }, Validators.compose([Validators.maxLength(1500)])),
      // activated: new FormControl(data.activated),
      observation_professiogram: new FormControl({ value: data.observation_professiogram, disabled: !companyPermissions }, (companyPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(2000)]) : null),

      // company
      company: new FormGroup({
        identification_number: new FormControl({ value: data.company.identification_number, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(100)]) : null),
        name: new FormControl({ value: data.company.name, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
        address: new FormControl({ value: data.company.address, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
        economic_activity: new FormControl({ value: data.company.economic_activity, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
        legal_representative_identification_number: new FormControl({ value: data.company.legal_representative_identification_number, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern("^[0-9]*$")]) : null),
        legal_representative_name: new FormControl({ value: data.company.legal_representative_name, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
        legal_representative_employee_position: new FormControl({ value: data.company.legal_representative_employee_position, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
        director_rrhh: new FormControl({ value: data.company.director_rrhh, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
        city: new FormControl({ value: data.company.city, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(70)]) : null),
        phone: new FormControl({ value: data.company.phone, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]) : null),
        web: new FormControl({ value: data.company.web, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required, Validators.maxLength(300)]) : null),
        mission: new FormControl({ value: data.company.mission, disabled: !companyPermissions }, (companyPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),
        vission: new FormControl({ value: data.company.vission, disabled: !companyPermissions }, (companyPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),
        corporate_values: new FormControl({ value: data.company.corporate_values, disabled: !companyPermissions }, (companyPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(2000)]) : null),
        address_description: new FormControl({ value: data.company.address_description, disabled: !companyPermissions }, selectionPermissions ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),
        parking: new FormControl({ value: data.company.parking, disabled: !companyPermissions }, selectionPermissions ? Validators.compose([Validators.required]) : null),
        food: new FormControl({ value: data.company.food, disabled: !companyPermissions }, selectionPermissions ? Validators.compose([Validators.required]) : null),
        transport: new FormControl({ value: data.company.transport, disabled: !companyPermissions }, selectionPermissions ? Validators.compose([Validators.required]) : null),
        inscription_cc_at: new FormControl({ value: data.company.inscription_cc_at, disabled: !companyPermissions }, companyPermissions ? Validators.compose([Validators.required]) : null),
      }),

      // supplies
      supply_type: new FormControl({ value: data.supply_type, disabled: !supplyPermissions }, supplyPermissions ? Validators.compose([Validators.required, Validators.maxLength(400)]) : null),
      supply_person: new FormControl({ value: data.supply_person, disabled: !supplyPermissions }, (supplyPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      supply_information: new FormControl({ value: data.supply_information, disabled: !supplyPermissions }, supplyPermissions ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),

      // service_client
      service_client_contact_atc: new FormControl({ value: data.service_client_contact_atc, disabled: !serviceClientPermissions }, serviceClientPermissions ? Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
      service_client_frecuency_visit: new FormControl({ value: data.service_client_frecuency_visit, disabled: !serviceClientPermissions }, serviceClientPermissions ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      service_client_email: new FormControl({ value: data.service_client_email, disabled: !serviceClientPermissions }, (serviceClientPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')]) : null),
      service_client_mobile: new FormControl({ value: data.service_client_mobile, disabled: !serviceClientPermissions }, (serviceClientPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]) : null),
      service_client_facilitator: new FormControl({ value: data.service_client_facilitator, disabled: !serviceClientPermissions }, (serviceClientPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required]) : null),
      service_client_facilitator_person: new FormControl({ value: data.service_client_facilitator_person, disabled: !serviceClientPermissions }, Validators.compose([Validators.maxLength(100)])),
      service_client_schedule: new FormControl({ value: data.service_client_schedule, disabled: !serviceClientPermissions }, serviceClientPermissions ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      service_client_report: new FormControl({ value: data.service_client_report, disabled: !serviceClientPermissions }, (serviceClientPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required]) : null),
      service_client_aditional_information: new FormControl({ value: data.service_client_aditional_information, disabled: !serviceClientPermissions }, serviceClientPermissions ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),

      // hse
      hse_contact: new FormControl({ value: data.hse_contact, disabled: !hsePermissions }, Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')])),
      hse_contact_employee_position: new FormControl({ value: data.hse_contact_employee_position, disabled: !hsePermissions }, Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')])),
      hse_contact_email: new FormControl({ value: data.hse_contact_email, disabled: !hsePermissions }, Validators.compose([Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])),
      hse_contact_phone: new FormControl({ value: data.hse_contact_phone, disabled: !hsePermissions }, Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')])),
      hse_arl_base: new FormControl({ value: data.hse_arl_base, disabled: !hsePermissions }, Validators.compose([Validators.required, Validators.maxLength(100)])),
      hse_risk: new FormControl({ value: data.hse_risk, disabled: !hsePermissions }, !userCompanyPermissions ? Validators.compose([Validators.required, Validators.maxLength(50)]) : null),
      hse_additional_information: new FormControl({ value: data.hse_additional_information, disabled: !hsePermissions }, Validators.compose([Validators.required, Validators.maxLength(4000)])),

      // selection
      selection_contact: new FormControl({ value: data.selection_contact, disabled: !selectionPermissions }, selectionPermissions ? Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
      selection_contact_employee_position: new FormControl({ value: data.selection_contact_employee_position, disabled: !selectionPermissions }, selectionPermissions ? Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
      selection_contact_email: new FormControl({ value: data.selection_contact_email, disabled: !selectionPermissions }, selectionPermissions ? Validators.compose([Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')]) : null),
      selection_contact_phone: new FormControl({ value: data.selection_contact_phone, disabled: !selectionPermissions }, (selectionPermissions && userCompanyPermissions) ? Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]) : null),
      selection_contact_mobile: new FormControl({ value: data.selection_contact_mobile, disabled: !selectionPermissions }, selectionPermissions ? Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]) : null),
      selection_contact_employee_position_provider: new FormControl({ value: data.selection_contact_employee_position_provider, disabled: !selectionPermissions }, (selectionPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(100)]) : null),
      selection_dossier_required: new FormControl({ value: data.selection_dossier_required, disabled: !selectionPermissions }, (selectionPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      selection_dossier: new FormControl({ value: data.selection_dossier, disabled: !selectionPermissions }, Validators.compose([Validators.maxLength(100)])),
      selection_schedule: new FormControl({ value: data.selection_schedule, disabled: !selectionPermissions }, (selectionPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      selection_additional_information: new FormControl({ value: data.selection_additional_information, disabled: !selectionPermissions }, selectionPermissions ? Validators.compose([Validators.required, Validators.maxLength(5000)]) : null),
      first_day_instruction: new FormControl({ value: data.first_day_instruction, disabled: !selectionPermissions }, selectionPermissions ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),
      selection_family_restriction: new FormControl({ value: data.selection_family_restriction, disabled: !selectionPermissions }, selectionPermissions ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      unique_contact: new FormControl({ value: data.unique_contact, disabled: !selectionPermissions }, (selectionPermissions && userCompanyPermissions) ? Validators.compose([Validators.required]) : null),
      selection_show_more_contact: new FormControl({ value: data.selection_show_more_contact, disabled: !selectionPermissions }),
      selection_contact2: new FormControl({ value: data.selection_contact2, disabled: !selectionPermissions }, Validators.compose([Validators.maxLength(100)])),
      selection_contact_phone2: new FormControl({ value: data.selection_contact_phone2, disabled: !selectionPermissions }, Validators.compose([Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')])),
      selection_contact_email2: new FormControl({ value: data.selection_contact_email2, disabled: !selectionPermissions }, Validators.compose([Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])),
      selection_contact3: new FormControl({ value: data.selection_contact3, disabled: !selectionPermissions }, Validators.compose([Validators.maxLength(100)])),
      selection_contact_phone3: new FormControl({ value: data.selection_contact_phone3, disabled: !selectionPermissions }, Validators.compose([Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')])),
      selection_contact_email3: new FormControl({ value: data.selection_contact_email3, disabled: !selectionPermissions }, Validators.compose([Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])),
      selection_contact4: new FormControl({ value: data.selection_contact4, disabled: !selectionPermissions }, Validators.compose([Validators.maxLength(100)])),
      selection_contact_phone4: new FormControl({ value: data.selection_contact_phone4, disabled: !selectionPermissions }, Validators.compose([Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')])),
      selection_contact_email4: new FormControl({ value: data.selection_contact_email4, disabled: !selectionPermissions }, Validators.compose([Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])),
      selection_contact5: new FormControl({ value: data.selection_contact5, disabled: !selectionPermissions }, Validators.compose([Validators.maxLength(100)])),
      selection_contact_phone5: new FormControl({ value: data.selection_contact_phone5, disabled: !selectionPermissions }, Validators.compose([Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')])),
      selection_contact_email5: new FormControl({ value: data.selection_contact_email5, disabled: !selectionPermissions }, Validators.compose([Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])),
      // 26 72
      // hire
      hire_contact: new FormControl({ value: data.hire_contact, disabled: !hirePermissions }, hirePermissions ? Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
      hire_contact_employee_position: new FormControl({ value: data.hire_contact_employee_position, disabled: !hirePermissions }, hirePermissions ? Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
      hire_contact_email: new FormControl({ value: data.hire_contact_email, disabled: !hirePermissions }, hirePermissions ? Validators.compose([Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')]) : null),
      hire_contact_phone: new FormControl({ value: data.hire_contact_phone, disabled: !hirePermissions }, hirePermissions ? Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]) : null),
      hire_pay_test: new FormControl({ value: data.hire_pay_test, disabled: !hirePermissions }, (hirePermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(255)]) : null),
      hire_other_test: new FormControl({ value: data.hire_other_test, disabled: !hirePermissions }, (hirePermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(500)]) : null),
      hire_pay_test_person: new FormControl({ value: data.hire_pay_test_person, disabled: !hirePermissions }, (hirePermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),
      hire_lab_test: new FormControl({ value: data.hire_lab_test, disabled: !hirePermissions }, (hirePermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(100)]) : null),
      hire_center_cost: new FormControl({ value: data.hire_center_cost, disabled: !hirePermissions }, (hirePermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(100)]) : null),
      hire_show_more_contact: new FormControl({ value: data.hire_show_more_contact, disabled: !hirePermissions }),
      hire_contact2: new FormControl({ value: data.hire_contact2, disabled: !hirePermissions }, Validators.compose([Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')])),
      hire_contact_phone2: new FormControl({ value: data.hire_contact_phone2, disabled: !hirePermissions }, Validators.compose([Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')])),
      hire_contact_email2: new FormControl({ value: data.hire_contact_email2, disabled: !hirePermissions }, Validators.compose([Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])),
      hire_contact3: new FormControl({ value: data.hire_contact3, disabled: !hirePermissions }, Validators.compose([Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')])),
      hire_contact_phone3: new FormControl({ value: data.hire_contact_phone3, disabled: !hirePermissions }, Validators.compose([Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')])),
      hire_contact_email3: new FormControl({ value: data.hire_contact_email3, disabled: !hirePermissions }, Validators.compose([Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])),
      hire_contact4: new FormControl({ value: data.hire_contact4, disabled: !hirePermissions }, Validators.compose([Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')])),
      hire_contact_phone4: new FormControl({ value: data.hire_contact_phone4, disabled: !hirePermissions }, Validators.compose([Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')])),
      hire_contact_email4: new FormControl({ value: data.hire_contact_email4, disabled: !hirePermissions }, Validators.compose([Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])),
      hire_contact5: new FormControl({ value: data.hire_contact5, disabled: !hirePermissions }, Validators.compose([Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')])),
      hire_contact_phone5: new FormControl({ value: data.hire_contact_phone5, disabled: !hirePermissions }, Validators.compose([Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')])),
      hire_contact_email5: new FormControl({ value: data.hire_contact_email5, disabled: !hirePermissions }, Validators.compose([Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')])),
      hire_description: new FormControl({ value: data.hire_description, disabled: !hirePermissions }, (hirePermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),
      hire_clausulas: new FormControl({ value: data.hire_clausulas, disabled: !hirePermissions }, (hirePermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(1500)]) : null),
      hire_additional_information: new FormControl({ value: data.hire_additional_information, disabled: !hirePermissions }, (hirePermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(5000)]) : null),
      // 25 97
      // payment
      payment_contact: new FormControl({ value: data.payment_contact, disabled: !paymentPermissions }, paymentPermissions ? Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
      payment_contact_employee_position: new FormControl({ value: data.payment_contact_employee_position, disabled: !paymentPermissions }, paymentPermissions ? Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
      payment_contact_email: new FormControl({ value: data.payment_contact_email, disabled: !paymentPermissions }, paymentPermissions ? Validators.compose([Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')]) : null),
      payment_contact_phone: new FormControl({ value: data.payment_contact_phone, disabled: !paymentPermissions }, paymentPermissions ? Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]) : null),
      payment_frecuency: new FormControl({ value: data.payment_frecuency, disabled: !paymentPermissions }, paymentPermissions ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      payment_date: new FormControl({ value: data.payment_date, disabled: !paymentPermissions }, paymentPermissions ? Validators.compose([Validators.required]) : null),
      payment_day: new FormControl({ value: data.payment_day, disabled: !paymentPermissions }, paymentPermissions ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      payment_peace_save: new FormControl({ value: data.payment_peace_save, disabled: !paymentPermissions }, (paymentPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required]) : null),
      payment_biometric_capture: new FormControl({ value: data.payment_biometric_capture, disabled: !paymentPermissions }, (paymentPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required]) : null),
      payment_date_end_invoce: new FormControl({ value: data.payment_date_end_invoce, disabled: !paymentPermissions }, (paymentPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required]) : null),
      payment_month_management: new FormControl({ value: data.payment_month_management, disabled: !paymentPermissions }, (paymentPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      payment_additional_information: new FormControl({ value: data.payment_additional_information, disabled: !paymentPermissions }, paymentPermissions ? Validators.compose([Validators.required, Validators.maxLength(5000)]) : null),
      payment_accounting_software: new FormControl({ value: data.payment_accounting_software, disabled: !paymentPermissions }, (paymentPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      payment_ss_operator: new FormControl({ value: data.payment_ss_operator, disabled: !paymentPermissions }, (paymentPermissions && !userCompanyPermissions) ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      // 14 111
      // accountancy
      accountancy_contact: new FormControl({ value: data.accountancy_contact, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
      accountancy_contact_employee_position: new FormControl({ value: data.accountancy_contact_employee_position, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,\\-\\.\\(\\);& ]*$')]) : null),
      accountancy_contact_email: new FormControl({ value: data.accountancy_contact_email, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$')]) : null),
      accountancy_contact_phone: new FormControl({ value: data.accountancy_contact_phone, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]) : null),
      accountancy_invoice_address: new FormControl({ value: data.accountancy_invoice_address, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      accountancy_regimen_tax: new FormControl({ value: data.accountancy_regimen_tax, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      accountancy_big_taxpayer: new FormControl({ value: data.accountancy_big_taxpayer, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      accountancy_autoretainer: new FormControl({ value: data.accountancy_autoretainer, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      accountancy_days_invoce_expiration: new FormControl({ value: data.accountancy_days_invoce_expiration, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      accountancy_days_invoce_radication: new FormControl({ value: data.accountancy_days_invoce_radication, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.maxLength(150)]) : null),
      accountancy_additional_information: new FormControl({ value: data.accountancy_additional_information, disabled: !accountancyPermissions }, accountancyPermissions ? Validators.compose([Validators.required, Validators.maxLength(5000)]) : null),
      // 11 122
      // documents guide
      documents_guide_customer: new FormGroup({
        commercial_chamber_certificate: this.fb.array([]),
        rut_certificate: this.fb.array([]),
        financial_statements: this.fb.array([]),
        company_income_tax_declaration: this.fb.array([]),
        copy_of_legal_representative_id: this.fb.array([]),
        central_consultation_form: this.fb.array([]),
        minimum_standards_certificate_from_arl_of_affiliation: this.fb.array([]),
        anti_money_laundering_declaration: this.fb.array([]),
        customer_guide_format: this.fb.array([]),
        commercial_proposal: this.fb.array([]),
        commercial_contract: this.fb.array([]),
        guarantees_or_payment: this.fb.array([]),
      }),
    });
  }

  // Getter para acceder al FormGroup principal de los documentos del formulario principal
  get documentsGuideForm(): FormGroup {
    return this.form.get("documents_guide_customer") as FormGroup;
  }

  public getFormArray(tipo: string) {
    return this.documentsGuideForm.get(tipo) as FormArray;
  }

  // Método que crea un nuevo FormGroup para el archivo
  public addFile(data: any = null, fileContent: any = null) {
    data = data || {
      id: undefined,
      attachment: fileContent ? fileContent.name : null,
      file: fileContent,
    };

    const fileForm = this.fb.group({
      id: [data.id],
      attachment: [data.attachment],
      file: data.file, // El archivo real no se cargará aquí
    });

    return fileForm;
  }

  // Método que maneja el cambio en la entrada de documentos
  public onDocumentsCustomerGuideChange(event: any, tipo: string) {
    const selectedDocuments = Array.from(event.target.files); // Convierte los archivos seleccionados a un array
    const formArray = this.getFormArray(tipo); // Obtén el FormArray correspondiente

    selectedDocuments.forEach((file) => {
      const documentGroup = this.addFile(null, file); // Crea un FormGroup para el archivo
      formArray.push(documentGroup); // Agrega el FormGroup al FormArray
    });
  }

  public removeDocument(tipo: string, index: number) {
    const formArray = this.getFormArray(tipo);
    const documentGroup = formArray.at(index) as FormGroup;

    if (documentGroup.get('file').value) {
      // Si el documento tiene un archivo (nuevo documento), simplemente eliminar del FormArray
      formArray.removeAt(index);
    } else {
      // Si el documento ya existe (no tiene un archivo), agregar su ID a la lista de IDs a eliminar
      const documentId = documentGroup.get('id').value;
      if (documentId) {
        this.removedDocumentIds.push(documentId);
      }
      // Eliminar del FormArray
      formArray.removeAt(index);
    }
  }

  public uploadDocuments(values: any, id: number) {
    const documentsGroup = values.documents_guide_customer; // Acceder al grupo de documentos
    const formData = new FormData(); // Crear un nuevo FormData

    // Iterar sobre cada tipo de documento en el grupo
    for (const key in documentsGroup) {
      if (documentsGroup.hasOwnProperty(key)) {
        const formArray = documentsGroup[key]; // Obtener el FormArray correspondiente

        // Verificar si el FormArray tiene documentos
        const hasDocuments = formArray.some((documentGroup: any) => documentGroup.file !== null);

        if (hasDocuments) { // Solo proceder si hay documentos
          // Iterar sobre cada documento en el FormArray
          formArray.forEach((documentGroup: any, index: number) => {
            const file = documentGroup.file; // Obtener el objeto File

            if (file) { // Comprobar si existe un archivo
              // Agregar el archivo al FormData
              formData.append(`documents[${key}][]`, file);
            }
          });
        }
      }
    }

    // Agregar los IDs de documentos a eliminar al FormData
    if (this.removedDocumentIds.length > 0) {
      formData.append('removed_documents', JSON.stringify(this.removedDocumentIds));
    }

    // Llamar al servicio para subir los documentos y manejar la respuesta
    this.customerGuideService.uploadCustomerGuideDocuments(id, formData).toPromise().then(
      (response) => {
        this.translate.get('documents uploaded').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
        });
      },
      (error) => {
        let msg = 'uploading documents';
        let msg_error = error._body;
        this.translate.get('error').subscribe((res: string) => {
          this.translate.get(msg).subscribe((res1: string) => {
            this.notificationsService.growlNotify('error', res + ' ' + res1 + msg_error);
          });
        });
      }
    );
  }

  public populateFormArrays(data: any) {
    // Asegúrate de que `data` tenga la propiedad `documents_customer_guide`
    if (data && data.documents_customer_guide) {
      // Iterar sobre los documentos recibidos
      data.documents_customer_guide.forEach(doc => {
        // Obtener el tipo de documento usando el `list_document_customer_guide_id` del documento
        const documentType = this.typesDocumentsCustomerGuide.find(tipo => tipo.id == doc.list_document_customer_guide_id);

        // Verificar que documentType no sea undefined
        if (documentType) {
          const documentTypeKey = documentType.key; // Ahora es seguro acceder a la key

          // Obtener el FormArray correspondiente
          const formArray = this.getFormArray(documentTypeKey);

          // Agregar el FormGroup al FormArray
          formArray.push(this.fb.group({
            id: [doc.id],
            attachment: [doc.name],
            name: [doc.name],
            file: null // Aquí el archivo real no se cargará, solo se almacena la información del archivo
          }));
        } else {
          // Manejar el caso donde no se encontró el tipo de documento, si es necesario
          console.warn(`No se encontró el tipo de documento para id: ${doc.list_document_customer_guide_id}`);
        }
      });
    }
  }

  public gotoDocument(id) {
    window.open(this.apiUrl + '/customer-guides-documents/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
  }

  private setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.company_latitude = position.coords.latitude;
        this.company_longitude = position.coords.longitude;
        this.zoom = 17;
      });
    }
  }

  private setPosition(position) {
    this.company_latitude = position.lat;
    this.company_longitude = position.lng;
    this.zoom = 17;
  }

  public handleMapClick(event) {
    this.company_selectedPosition = event.latLng;
    this.addMarker(this.company_selectedPosition.lat(), this.company_selectedPosition.lng());
  }

  public addMarker(lat, lng) {
    const title = (this.form.controls.company_name.value !== '') ? this.form.controls.company_name.value : 'company';
    this.company_longitude = lng;
    this.company_latitude = lat;
    this.company_overlays = [];
    this.company_overlays.push(
      new google.maps.Marker({
        position: {
          lat: lat,
          lng: lng
        }, title: title
      }
      )
    );
  }

  markerDragEnd(m: Marker, $event: any) {
    this.company_latitude = $event.coords.lat;
    this.company_longitude = $event.coords.lng;
  }

  public cancelCustomerGuide() {
    // console.log('reset');
    this.form.reset();
    this.close.emit(true);
    this.router.navigateByUrl('/pages/customer-guides');
  }

  public saveandexit(values) {
    this.save_exit = true;
    this.newCustomerGuide(values);
  }

  public newCustomerGuide(values) {
    if (!this.company_addressGoogle)
      this.company_addressGoogle = values.company.company_address;

    values.start_contract_date = (values.start_contract_date ? formatDate(values.start_contract_date) : null);
    values.end_contract_date = (values.end_contract_date ? formatDate(values.end_contract_date) : null);

    if (values.company) {
      values.company.name = values.company.name ? values.company.name.toUpperCase() : undefined;
      values.company.latitude = this.company_latitude;
      values.company.longitude = this.company_longitude;
      values.company.inscription_cc_at = formatDateWithouthHourConditional(values.company.inscription_cc_at);
    }

    if (values && this.form.valid) {
      const promise = (this.edit) ?
        this.customerGuideService.updateCustomerGuide(this.edit.id, values)
        :
        this.customerGuideService.newCustomerGuide(values);

      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('saved').subscribe((res: string) => {
            this.notificationsService.growlNotify('success', res);
            if (this.save_exit) {
              var resp = response.json();
              let id_loc = this.edit ? this.id : resp.id;
              this.uploadDocuments(values, id_loc);
              this.close.emit(true);
              this.form.reset();
              this.save_exit = false;
              this.router.navigateByUrl('/pages/customer-guides');
            }
          });
        },
        error => {
          let msg = 'saving customer guide';
          let msg_error = error._body;
          this.translate.get('error').subscribe((res: string) => {
            this.translate.get(msg).subscribe((res1: string) => {
              this.notificationsService.growlNotify('error', res + ' ' + res1 + msg_error);
            })
          });
        }
      );
    }
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public onUpload(event: any) {
    this.uploadedProfessiogram = [];
    for (const file of event.srcElement.files) {
      this.uploadedProfessiogram.push(file);
    }
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        this.prewiewProfessiogram = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public updateProfessiogram(event: any) {
    this.uploadedProfessiogram = [];
    for (const file of event.files) {
      this.uploadedProfessiogram.push(file);
    }

    this.promiseProfessiogram = this.uploadFilesService.updateProfessiogram(this.uploadedProfessiogram, this.edit.id).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push({ severity: 'success', summary: res });
        });
        // this.getProfile();
        // this.avatar = this.prewiewProfessiogram;
      },
      error => {
        let errorMsg = '';
        errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorMsg });
      }
    );
  }

  public gotoProfessiogram() {
    window.open(this.apiUrl + '/customer-guides/' + this.edit.id + '/professiogram' + '?token=' + localStorage.getItem('token'), '_blank');
  }

  public downloadProfessiogram() {
    this.promiseProfessiogram = this.uploadFilesService.getProfessiogram(this.edit.id).toPromise().then(
      response => {
      },
      error => {
        let errorMsg = '';
        errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorMsg });
      }
    );
  }

  public onUploadFileSelection(event: any) {
    // this.uploadedFileSelection = [];
    // for (const file of event.srcElement.files) {
    //     this.uploadedFileSelection.push(file);
    // }
    // if (event.target.files && event.target.files[0]) {
    //     const reader = new FileReader();
    //     reader.onload = () => {
    //       this.prewiewFileSelection = reader.result;
    //     };
    //     reader.readAsDataURL(event.target.files[0]);
    // }
    // console.log(event);
  }

  public updateFileSelection(event: any) {
    this.uploadedFileSelection = [];
    for (const file of event.files) {
      this.uploadedFileSelection.push(file);
    }

    this.promiseFileSelection = this.uploadFilesService.updateFileSelection(this.uploadedFileSelection, this.edit.id).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push({ severity: 'success', summary: res });
        });
        // this.getProfile();
        // this.avatar = this.prewiewFileSelection;
      },
      error => {
        let errorMsg = '';
        errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorMsg });
      }
    );
  }
  public updateFileSelectionMultiple(event: any, fileUpload: FileUpload) {

    this.loading_upload = true;
    this.uploadedFileSelection = [];
    for (const file of event.files) {
      this.uploadedFileSelection.push(file);
    }

    this.promiseFileSelection = this.uploadFilesService.updateFileSelectionMultiple(this.uploadedFileSelection, this.edit.id).toPromise().then(
      response => {
        fileUpload.clear();
        this.translate.get('saved').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push({ severity: 'success', summary: res });
        });
        this.showFilesSelection(this.edit.id);
        // this.getProfile();
        // this.avatar = this.prewiewFileSelection;
      },
      error => {
        this.loading_upload = false;
        let errorMsg = '';
        errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorMsg });
      }
    );
  }
  public deleteAttachmentFileSelectionMultiple(id) {
    this.promiseFileSelection = this.uploadFilesService.deleteAttachmentFileSelectionMultiple(id).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
        });
        // delete this.uploadedAttachment[id];
        this.showFilesSelection(this.edit.id);
      },
      error => {
        let msg = '';
        this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
          this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
            JSON.parse(error._body).errors.forEach(element => {
              if (element.source) {
                if (element.source.pointer) {
                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    msg = msg + res3 + ', ';
                  });
                }
              }
            });
            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
          });
        });
      }
    );
  }

  public gotoFileSelection() {
    window.open(this.apiUrl + '/customer-guides/' + this.edit.id + '/file-selection' + '?token=' + localStorage.getItem('token'), '_blank');
  }
  public gotoFileSelectionMult(id) {
    window.open(this.apiUrl + '/customer-guides/' + id + '/file-selection-multiple-docs' + '?token=' + localStorage.getItem('token'), '_blank');
  }
  public downloadFileSelection() {
    this.promiseFileSelection = this.uploadFilesService.getFileSelection(this.edit.id).toPromise().then(
      response => {
      },
      error => {
        let errorMsg = '';
        errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorMsg });
      }
    );
  }

  public onUploadServiceClientFileReport(event: any) {
    this.uploadedServiceClientFileReport = [];
    for (const file of event.srcElement.files) {
      this.uploadedServiceClientFileReport.push(file);
    }
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        this.prewiewServiceClientFileReport = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public updateServiceClientFileReport(event: any) {
    this.uploadedServiceClientFileReport = [];
    for (const file of event.files) {
      this.uploadedServiceClientFileReport.push(file);
    }

    this.promiseServiceClientFileReport = this.uploadFilesService.updateServiceClientFileReport(this.uploadedServiceClientFileReport, this.edit.id).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push({ severity: 'success', summary: res });
        });
        // this.getProfile();
        // this.avatar = this.prewiewServiceClientFileReport;
      },
      error => {
        let errorMsg = '';
        errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorMsg });
      }
    );
  }

  public gotoServiceClientFileReport() {
    window.open(this.apiUrl + '/customer-guides/' + this.edit.id + '/service-client-file-report' + '?token=' + localStorage.getItem('token'), '_blank');
  }

  public downloadServiceClientFileReport() {
    this.promiseServiceClientFileReport = this.uploadFilesService.getServiceClientFileReport(this.edit.id).toPromise().then(
      response => {
      },
      error => {
        let errorMsg = '';
        errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorMsg });
      }
    );
  }

  getFormValidationErrors(form) {
    let value = ''; let variable_control = false;
    // console.log("getformvalidation");
    var array_forms = Object.keys(form.controls);
    value = this.getErrorString(array_forms, form);
    if (value == '') {
      var array_forms_company = Object.keys(form.controls.company.controls);
      value = this.getErrorString(array_forms_company, form.controls.company);
    }
    return value;
    //array_forms.forEach(key => {

  }

  public getErrorString(array_forms: any, form_local: any) {
    var value = '';
    for (var i = 0; i < array_forms.length; i++) {
      var key = array_forms[i];
      const controlErrors: ValidationErrors = form_local.get(key).errors;
      if (controlErrors != null) {
        // Object.keys(controlErrors).forEach(keyError => {
        let keyError = Object.keys(controlErrors)[0];
        let key_with_spaces = this.deleteUnderLine(key);
        let key_translated, error_translated;
        this.translate.get(key_with_spaces).subscribe((res: string) => {
          key_translated = res;
        });

        this.translate.get(keyError).subscribe((res: string) => {
          error_translated = res;
        });

        // value = 'Key control: ' + key_translated + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
        value = 'Campo: ' + key_translated + ', Error: ' + error_translated;
        //variable_control = true;
        i = array_forms.length++;
        // });
      }
      //if(variable_control)
      //return;

    };
    return (value);
  }
  deleteUnderLine(chain: string): string {
    // Usar el método replace con una expresión regular para reemplazar todos los guiones bajos por espacios
    return chain.replace(/_/g, ' ');
  }

  printCustomerGuide() {
    window.open(this.apiUrl + '/customer-guides/' + this.edit.id + '/pdf?token=' + localStorage.getItem('token'), '_blank');
  }

  public showFilesSelection(customer_guide_id) {

    // this.selectContract = contract;
    // this.selectContractType = type;
    // this.uploadedAttachment = [];
    // var citation_id = contract.citation_id;
    // var profile_survey_id = contract.profile_survey_id;
    var result;
    //Promesa que combina DocumentProfileSurvey->  //Función que obtiene los documentos subidos para un contrato
    // y CheckList->Función que obtiene los documentos requeridos para un perfil de cargo

    this.customerGuideService.getDocumentsCustomerGuide(customer_guide_id).toPromise().then(
      response => {
        this.listDocuments = [];
        result = response.json().data;
        let list = [...this.listDocuments];
        this.listDocuments = result;
        // this.modViewDialogDocumentation = true;
        this.loading_upload = false;
      },
      error => {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'error' });
      }
    );
  }

  public editValues() {

    if (this.edit.start_contract_date != null)
      this.edit.start_contract_date = new Date(this.edit.start_contract_date);

    if (this.edit.end_contract_date != null)
      this.edit.end_contract_date = new Date(this.edit.end_contract_date);

    this.edit.company.inscription_cc_at = new Date(this.edit.company.inscription_cc_at);

    this.createForm(this.edit);
    this.showFilesSelection(this.edit.id);

    if (this.edit.professiogram) {
      this.uploadedProfessiogram = [];
      this.uploadedProfessiogram.push({ 'name': 'Profesiograma Adjunto  ' });
    }

    if (this.edit.file_selection) {
      this.uploadedFileSelection = [];
      this.uploadedFileSelection.push({ 'name': 'Archivo Adjunto  ' });
    }

    if (this.edit.service_client_file_report) {
      this.uploadedServiceClientFileReport = [];
      this.uploadedServiceClientFileReport.push({ 'name': 'Archivo Adjunto  ' });
    }

    this.company_addressGoogle = this.edit.company.address;

    if (this.edit.company.latitude && this.edit.company.longitude) {
      const lat = this.edit.company.latitude;
      const lng = this.edit.company.longitude;
      const position = {
        lat: lat,
        lng: lng
      };
      this.setPosition(position);
    }

    this.mapsAPILoader_load();

  }

  public defaultValues() {
    this.createForm();
    this.setCurrentPosition();
    this.mapsAPILoader_load();
  }

  public mapsAPILoader_load() {
    var countInterval = 0;
    const waitForElement = setInterval(() => {
      countInterval++;
      if (this.searchElementRef && this.searchElementRef.nativeElement) {
        clearInterval(waitForElement);

        this.mapsAPILoader.load().then(() => {
          const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
            types: ['address']
          });
          autocomplete.addListener('place_changed', () => {
            this.ngZone.run(() => {
              // get the place result
              const place: google.maps.places.PlaceResult = autocomplete.getPlace();

              this.company_addressGoogle = place.formatted_address;
              // verify result
              if (place.geometry === undefined || place.geometry === null) {
                return;
              }

              // set latitude, longitude and zoom
              this.company_latitude = place.geometry.location.lat();
              this.company_longitude = place.geometry.location.lng();
              this.zoom = 17;
            });
          });
        });
      }
      if (countInterval == 20)
        clearInterval(waitForElement);
    }, 100);

  };

  public updateDocumentsfromChild($event: Event) {
    this.getDocumentsHseCustomerGuide(this.id);
  }

  public getDocumentsHseCustomerGuide(customer_guide_id: number) {
    this.customerGuideHseDocumentsService.getAttachmentCustomerGuide(customer_guide_id).toPromise().then(
      response => {
        this.documents_hse = response.json();
      },
      error => {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'error' });
      }
    );
  }

  public getListDocumentsHseCustomerGuide(customer_guide_id: number) {
    this.customerGuideHseDocumentsService.getListHseDocumentsCustomerGuide(customer_guide_id).toPromise().then(
      response => {
        this.list_documents_customer_guide_hse = response.json();
        var documents_hse = [];
        for (let j = 0; j < this.list_documents_customer_guide_hse.length; j++) {
          for (let k = 0; k < this.list_documents_customer_guide_hse[j].documents_customer_guide_hse.length; k++) {
            documents_hse.push(this.list_documents_customer_guide_hse[j].documents_customer_guide_hse[k]);
          }
        }
        this.documents_hse = documents_hse;
      },
      error => {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'error' });
      }
    );
  }

  public copyBusiness(customer_guide_id, business_id) {
    this.copyCustomerGuide(customer_guide_id, business_id);
    this.save_exit = true;
  }

  public copyCustomerGuide(customer_guide_id, business_id: any): void {
    if (customer_guide_id && business_id) {
      this.promiseForm = this.customerGuideService.copyCustomerGuide(customer_guide_id, business_id).toPromise().then(
        (response) => {
          this.translate.get("copied").subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);

            if (this.save_exit) {
              //this.close.emit(response);
              this.form.reset();
              this.router.navigateByUrl("/pages/customer-guides");
              this.save_exit = false;
            }
          });

          // if (!this.barcode && !this.minimum) {
          //   this.router.navigateByUrl("/pages/selection/candidates-synergo");
          // }
        },
        (error) => {
          const errors_body = JSON.parse(error._body);
          const translations = errors_body.errors.map((element) => {
            let translationKey = element.detail;
            if (element.source && element.source.pointer) {
              translationKey += `, ${element.source.pointer}`;
            }
            return this.translate
              .get(translationKey)
              .map((translation: string) => translation);
          });
          // Observable.forkJoin(translations).subscribe((results: string[]) => {
          //   const combinedMessage = results.join(" ");
          //   this.notificationsService.growlNotify("error", combinedMessage);
          // });
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/customer-guides/new-customer-guide/new-customer-guide.component.ts